<template>
  <div :class="isOverlay ? 'cards-game-wrap overlayed' : 'cards-game-wrap'">
    <div class="close--overlay" 
      v-if="isOverlay"
      @click="() => transitionOut()"
    >
      <img src="../assets/close-dishe-arrow.svg" />
      <span>chat</span>
    </div>
    <div class="intro-game-cards">
      <div class="intro--page section--slide">
        <img class="logo-section" src="../assets/menu-item-eatsmart.svg" />
        <h2 class="title-section">
          {{
            $i18n.locale == 'it' ?
            "FAI LA TUA PARTE, MANGIA SMART"
            :
            "DO YOUR PART, EAT SMART"
          }}
        </h2>
        <p class="subtitle-section">
          {{
            $i18n.locale == 'it' ?
            "Scopri quanto sono sane le tue scelte quotidiane mettendole alla prova!"
            :
            "See how healthy your daily choices are by putting them to the test!"
          }}</p>
      </div>
      <div class="intro--earth section--slide">
        <div class="intro-chat-wrap">
          <div class="intro-chat-earth">
            <div class="balloon-intro">
              <p>
                {{ 
                  $i18n.locale == 'it' ?
                  "Ho preparato un gioco veloce per farti scoprire quanto è sano e sostenibile il tuo rapporto attuale con il cibo."
                  :
                  "I’ve prepared a quick game for you to see how healthy and sustainable your relationship with food is now."
                
                }}
                <br />
                <br />
                {{
                  $i18n.locale == 'it' ?
                  "Metti alla prova le tue attuali scelte alimentari trascinando ogni carta sul lato che descrive meglio le tue abitudini!"
                  :
                  "Put your current food choices to the test by dragging each card to the side that describes your habits best!"

                }}
              </p>
            </div>
            <div class="button-intro" @click="showSlider">
              <p>{{
                $i18n.locale == 'it' ?
                "Giochiamo!"
                :
                "Let's play"
                }}
              </p>
            </div>
          </div>
          <img class="avatar-intro-earth" src="../assets/planet-intro-sdg.svg" />
        </div>
      </div>
    </div>
    <CardSwipeGame :isOverlay="isOverlay"/>
    <BadgesWrap  v-if="!isOverlay" :start="openBadgeType" :type="openBadgeType" :isOverlay="isOverlay" />

  </div>
</template>

<script>
import CardSwipeGame from '@/components/CardSwipeGame.vue'
import {gsap, TimelineMax, Power2} from 'gsap'
import BadgesWrap from '@/components/BadgesWrap.vue'
import {mapState} from 'vuex';

export default {
  name: 'CardsGameWrap',
  props: ['startCardsOverlay', 'isOverlay'],
  components: {
    CardSwipeGame,
    BadgesWrap
  },
  methods: {
    transitionIn(){
      this.$store.dispatch('setMenuCtaVisibility',!this.isOverlay);
      
      let TL = new TimelineMax();

      TL
      .to('.logo-section',{duration: .75, scale: 1, opacity:1, ease: Power2.easeOut})
      .to('.title-section',{duration: .75, y: 0, opacity:1, ease: Power2.easeOut},'-=.25')
      .to('.subtitle-section',{duration: .75, y: 0, opacity:1, ease: Power2.easeOut},'-=.25')
      .to('.intro-game-cards',{duration: .75, x: '-100vw', ease: Power2.easeOut},'+=2.5')
      .to('.avatar-intro-earth',{duration: .5, opacity:1, x: 0, ease: Power2.easeInOut},'-=.25')
      .to('.balloon-intro',{duration: .5, opacity:1, ease: Power2.easeInOut},'-=.25')
      .to('.button-intro',{duration: .5, opacity:1, ease: Power2.easeInOut},'-=.25')
    },
    transitionOut(){
    
     gsap.to('.cards-game-wrap', {duration: .75, left: '-100%', ease: Power2.easeInOut, 
        onComplete: () => {
          this.$store.dispatch('openOverlay', '')
          this.$store.dispatch('setMenuCtaVisibility',true);
          this.$store.dispatch('triggerReply')
        }
      })
      
    },
    showSlider(){
      gsap.to('.intro-game-cards',{duration: .75, x: '-200vw', ease: Power2.easeOut})
      gsap.to('.cards-swipe--wrap',{duration: .75, left: 0, ease: Power2.easeOut, onComplete: () => {
        if(this.isOverlay){
          gsap.to('.cards-game-wrap .close--overlay', {opacity: 1, duration: .75})
        }
      }})
    }
  },
  mounted(){

    if(!this.isOverlay) {
      gsap.to('.cards-game-wrap', {duration: .75, left: 0, ease: Power2.easeInOut})
      this.$store.dispatch('setMenuCtaVisibility',true);
      setTimeout(this.transitionIn, 1000)
    }
  },
  watch:{
    startCardsOverlay(val){

      if(val === true){
        gsap.to('.cards-game-wrap', {duration: .75, left: 0, ease: Power2.easeInOut})
        setTimeout(this.transitionIn, 1000)
      }
    }
  },
  computed:{
    ...mapState({
      openBadgeType: state => state.openBadgeType
    })
  }
}
</script>

<style lang="scss">
  .close--overlay{
    position: absolute;
    top: 60px;
    left: 70px;
    z-index: 6;
    cursor: pointer;
    opacity: 0;
    transition: opacity .5s ease-out;
    display: flex;
    flex-direction: row;
    img{
      margin-right: 20px;
    }
    span{
      color: #fff;
      font-size: 24px;
    }
    &:hover{
      opacity: .5;
    }
    @media screen and (max-width: 768px) {
      top: 20px;
      left: 20px;
      img{
        width: 10px;
      }
      span{
        font-size: 18px;
      }
    }
  }
  .cards-game-wrap{
    position: fixed;
    top: 0;
    left: 0%;
    height: 100vh;
    width: 100%;
    overflow: hidden;
    background-size: cover;
    background-position: 50%;
    background-image: url('../assets/section-bg-your-part.jpg');
    overflow: hidden;
    z-index: 4;
    &.overlayed{
      left: -100%;
      .intro-game-cards{
        flex-wrap: inherit;
      }
    }
    .intro-game-cards{
      position: relative;
      top: 0;
      left: 0;
      width: 200%;
      height: 100%;
      display: flex;
      align-items: center;
      flex-direction: row;
      flex-wrap: wrap;
    }
    h2 {
      font-weight: bold;
    }
    .section--slide{
      position: relative;
      height: 100vh;
      width: 100vw;
      text-align: center;
      display: flex;
      justify-content: center;
      flex-direction: column;
      &.intro--page{
        img{
          margin: 0  auto;
          transform: scale(.7);
          opacity: 0;
          max-width: 300px;
          @media screen and(max-width: 767px){
            width: 80%;
          }
        }
        .title-section{
          margin: 30px auto 20px;
          transform: translateY(50px);
          opacity: 0;
          font-size: 48px;
          color: #fff;
          padding: 0 40px;
          @media screen and(max-width: 767px){
            font-size: 24px;
            line-height: 30px;
            padding: 0 20px;
          }
        }
        .subtitle-section{
          margin: 0 auto 0;
          transform: translateY(50px);
          opacity: 0;
          color: #fff;
          font-size: 32px;
          padding: 0 40px;
          @media screen and(max-width: 767px){
            font-size: 18px;
            line-height: 24px;
            padding: 0 20px;
          }
        }
      }
      &.intro--earth{
        justify-content: flex-start;
        .hide-desktop{
          display: none;
          @media screen and(max-width: 767px){
            display: block;
          }
        }
      }
    }
    .intro-chat-wrap{
      position: relative;
      width: 80%;
      margin: 0 auto;
      top: 10%;
      .intro-chat-earth{
        position: relative;
        display: flex;
        flex-direction: column;
        padding: 0 80px;
        .balloon-intro{
          align-self: flex-start;
          padding: 50px 20px;
          background-color: #fff;
          border-top-right-radius: 5px;
          border-top-left-radius: 5px;
          border-bottom-right-radius: 5px;
          text-align: center;
          font-size: 24px;
          opacity: 0;
        }
        .button-intro{
          text-align: right;
          margin: 20px 0 0 auto;
          border: 1px solid #2E70E2;
          background-color: #2E70E2;
          color: #fff;
          padding: 16px 20px;
          font-size: 18px;
          border-radius: 5px;
          cursor: pointer;
          opacity: 0;
        }
      }
      @media screen and(max-width: 860px){
        top: 50%;
        transform: translateY(-50%);
        .intro-chat-earth{
          padding: 0 20px;
        }
      }
      @media screen and(max-width: 767px){
        width: 90%;
        .intro-chat-earth{
          .balloon-intro{
            padding: 20px 10px;
            font-size: 18px;
          }
        }
      }
    }
    .avatar-intro-earth{
      position: absolute;
      bottom: 0;
      transform: translateX(-100%) translateY(80%);
      left: 0;
      opacity: 0;
      width: 150px;
      @media screen and(max-width: 767px){
        width: 100px;
      }
    }
  } 
    
</style>